import { equals } from "ramda";

function getEnv() {
  if (equals(window.location.host, "app.upserve.com")) {
    return "production";
  }
  if (equals(window.location.host, "app.staging.upserve.com")) {
    return "staging";
  }
  return "development";
}

export default getEnv;
